import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=2f92aef0&scoped=true&lang=pug&"
import script from "./Common.vue?vue&type=script&lang=ts&"
export * from "./Common.vue?vue&type=script&lang=ts&"
import style0 from "./Common.vue?vue&type=style&index=0&id=2f92aef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f92aef0",
  null
  
)

export default component.exports